<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
        <div class="gray-dashed items-center">
            <label>授權人(即持卡人)/身分證統一證號 </label>
            <div class="content">
                <span><slot name="holder-id" /></span><br>
                <span><slot name="holder-name" /></span>
            </div>
        </div>
        <div class="gray-dashed items-baseline md:col-span-2">
            <label>信用卡卡號</label>
            <div class="content">
                <slot name="input" />
                <p>發卡機構：{{ data?.cardBankName || '' }}</p>
                <p>(限VISA、MASTER、聯合信用卡、JCB及AE卡)</p>
            </div>
        </div>
        <div class="gray-dashed items-baseline md:col-span-2">
            <label>有效月年</label>
            <div class="content">
                <div class="flex flex-wrap w-[12rem]">
                    <slot name="select" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EUDC } from '@/utils/EUDC';

export default {
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    setup() {
        EUDC();
    }
};
</script>

<style scoped lang="scss">
.gray-dashed {
    @apply border-t border-dashed border-gray-200 pt-2.5 pb-2 flex  min-h-[3rem];
    label {
        @apply flex-shrink-0 mr-4 text-sm xs:text-base text-gray-400 w-1/4 md:w-1/3 md:w-[7rem] min-w-[6.5rem];
    }
    .content {
        @apply text-base xs:text-lg;
    }
}
</style>
